import { render, staticRenderFns } from "./RecorridoFee.vue?vue&type=template&id=4adf1d9c&lang=pug"
import script from "./RecorridoFee.vue?vue&type=script&lang=js"
export * from "./RecorridoFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports